import { Icon, Modal, notification } from 'antd'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Id } from 'src/types'
import { Input } from 'src/components/Ant'
import { SaveTitleRequest } from 'src/services/api/requests'

interface Props {
  organizationId: Id
  requestId: Id
  title: string
  update: () => void
}

function IconEditRequestTitle({
  organizationId,
  requestId,
  title,
  update
}: Props) {
  const { t } = useTranslation()
  const inputText = useRef(null)
  const content = (
    <Input
      allowClear={false}
      defaultValue={title}
      onChange={e => (inputText.current = e.target.value)}
    />
  )
  return (
    <Icon
      type="edit"
      twoToneColor="#40a9ff"
      theme="twoTone"
      onClick={() => {
        Modal.confirm({
          cancelText: t('common.actions.cancel'),
          content,
          okText: t('common.actions.yes'),
          onCancel() {},
          onOk: async () => {
            const inputValue = inputText.current?.trim() ?? ''
            if (inputValue.length < 1) {
              notification.error({
                message: t('web.user.common.required_data'),
                placement: 'bottomRight'
              })
              return
            }

            const response = await SaveTitleRequest({
              title: inputValue,
              organization_id: organizationId,
              request_id: requestId
            })
            if (response.status !== 200) {
              notification.error({
                message: t('common.response.status-500'),
                placement: 'bottomRight'
              })
              return
            }
            notification.success({
              message: t('common.edit-done-successfully'),
              placement: 'bottomRight'
            })
            update()
          },
          title: t('web.setup.form.field-title.placeholder')
        })
      }}
    />
  )
}

export { IconEditRequestTitle }
